/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { ErrorCodes, PlatformName, PlatformProvider, ToastDuration, ToastService } from '@shared';
import { WorkBookFileData } from '../models';
import { LoggingService } from '@shared/logging';
import * as XLSX from 'xlsx';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { TranslateService } from '@ngx-translate/core';
import { ReportFileExporter } from 'report-file-exporter/src';
import { error } from 'protractor';

@Injectable()
export class FileWriterService {
	private isPlatformWeb: boolean;
	private fileExtension: string;

	public constructor(
		private platformProvider: PlatformProvider,
		private loggingService: LoggingService,
		private toastService: ToastService,
		private translateService: TranslateService
	) {
		this.isPlatformWeb = platformProvider.getPlatform() === PlatformName.WEB;
	}

	public async writeFile(workBookFileDataArray: WorkBookFileData[], fileExtension: string): Promise<void> {
		this.fileExtension = fileExtension;
		try {
			if (this.isPlatformWeb) {
				await this.writeFileOnWeb(workBookFileDataArray);
			} 
			if (!this.isPlatformWeb) {
				await this.writeFileOnMobile(workBookFileDataArray);
			}

			this.toastService.presentSuccess(
				this.translateService.instant('entry.export.successMessages.exportSuccessful'),
				ToastDuration.Fast
			);
		} catch (error) {
			console.log(error, "Error")
			this.toastService.presentError(
				this.translateService.instant('entry.export.errorMessages.exportFailed'),
				ToastDuration.Slow
			);
			this.loggingService.error(ErrorCodes.CSVFileExporterServiceError, error.toString());
		}
	}

	private async writeFileOnWeb(workBookFileDataArray: WorkBookFileData[]): Promise<void> {
		const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

		for (let index = 0; index < workBookFileDataArray.length; index++) {
			const workBookFileData = workBookFileDataArray[index];
			try {
				console.log(`Attempting to write file: ${workBookFileData.name}.${this.fileExtension}`, workBookFileData.file, index);
				
				await XLSX.writeFile(workBookFileData.file, `${workBookFileData.name}.${this.fileExtension}`);
				
				console.log(`Successfully wrote file: ${workBookFileData.name}.${this.fileExtension}`);
				
				// Introduce a delay between write operations
				await sleep(100); // 100ms delay, adjust as needed
			} catch (error) {
				console.error(`Failed to write file: ${workBookFileData.name}.${this.fileExtension}`, error);
			}
		}
	}

	private async writeFileOnMobile(workBookFileDataArray: WorkBookFileData[]): Promise<void> {
		const fileURIs: string[] = [];
		for (const workBookFileData of workBookFileDataArray) {
			const base64EncodedFile = XLSX.write(workBookFileData.file, {
				bookType: this.fileExtension as XLSX.BookType,
				type: 'base64'
			});
			const fileMetadata = await Filesystem.writeFile({
				path: `${workBookFileData.name}.${this.fileExtension}`,
				data: base64EncodedFile,
				directory: Directory.Cache
			});
			fileURIs.push(fileMetadata.uri);
		}

		if (this.platformProvider.getPlatform() === PlatformName.ANDROID) {
			try {
				await ReportFileExporter.writeReport({
					fileNames: workBookFileDataArray.map(
						(workBookFileData: WorkBookFileData) => `${workBookFileData.name}.${this.fileExtension}`
					)
				});
			} catch (error) {
				this.loggingService.error(ErrorCodes.CSVFileExporterServiceError, error.toString());
			}
		} else {
			await Share.share({ files: fileURIs });
		}

		for (const workBookFileData of workBookFileDataArray) {
			await Filesystem.deleteFile({
				path: `${workBookFileData.name}.${this.fileExtension}`,
				directory: Directory.Cache
			});
		}
	}
}
